<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-between py-3">
        <div class="col-lg-6 mb-4 mb-lg-0">
          <div
            class="text-sm text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          ></div>
        </div>

        <div
          class="col-lg-6 d-flex justify-content-lg-end justify-content-center"
        >
          <span class="text-muted text-sm">
            © {{ new Date().getFullYear() }}
            <a href="#" class="fw-bold text-decoration-none ms-1">MedleyHMS</a>
            Team
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
